import { axios, BaseApiUrl } from '../axios_config';

// 全部发货
export const AllBoxDelivery = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/AllBoxDelivery`, { ...params }).then(res => res.data);
}

// 清空重扫
export const ClearScanAllBoxInfo = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/ClearScanAllBoxInfo`, { ...params }).then(res => res.data);
}

// 删除已扫箱
export const DeleteScanBoxInfo = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/DeleteScanBoxInfo`, { ...params }).then(res => res.data);
}

// 装车扫描列表数据
export const GetPutOnCarListByContainerNo = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/GetPutOnCarListByContainerNo`, { ...params }).then(res => res.data);
}

// 已扫/未扫描箱子列表数据 
export const GetScanOrNoScanBoxListData = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/GetScanOrNoScanBoxListData`, { ...params }).then(res => res.data);
}

// 根据货柜号/SKU查询货柜信息
export const GetWaitPutOnCarListByContainerNoOrSku = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/GetWaitPutOnCarListByContainerNoOrSku`, { ...params }).then(res => res.data);
}

// 提交
export const PutOnCarSubmit = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/PutOnCarSubmit`, { ...params }).then(res => res.data);
}

// 扫描装车箱码
export const ScanCodeDeliveryBox = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/ScanCodeDeliveryBox`, { ...params }).then(res => res.data);
}

// 扫描装车不发箱码
export const ScanCodeNoDeliveryBox = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/ScanCodeNoDeliveryBox`, { ...params }).then(res => res.data);
}

// 移动端查询装车数据汇总
export const getloadingCount = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetloadingCountByTransportType`, { params }).then(res => res.data);
}

// 装车图片
export const GetPutOnCarLoadingReviewImageListType = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/GetPutOnCarLoadingReviewImageListType`, { ...params }).then(res => res.data);
}